import { render, staticRenderFns } from "./TissTable.vue?vue&type=template&id=82530cb6&"
import script from "./TissTable.vue?vue&type=script&lang=js&"
export * from "./TissTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports